import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import ClinicStates from './screens/index.vue';
const ClinicStates = () => import('./screens/index.vue')

const clinicStatesRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CLINIC_STATES_VIEW,
    PERMISSIONS_KEYS.CLINIC_STATES_INSERT,
    PERMISSIONS_KEYS.CLINIC_STATES_EDIT,
  ])
) {
  clinicStatesRoutes.push({
    path: '/estados-clinicos',
    name: 'Cadastro / Consulta|Estado Clínico',
    component: ClinicStates,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { clinicStatesRoutes };

